<template>
  <div>
    <el-form label-position="right">
      <title-and-description :field="field" />
      <el-row :gutter="30">
      
              <el-col :span="12">
          <div class="mt-2 field-required">
            <el-row :gutter="10">
              <el-col :span="10">Select Default Field</el-col>
              <el-col :span="14">
                <div class="form-group">
                   <el-radio v-model="field.default_value" label="YES">YES</el-radio>
                     <el-radio v-model="field.default_value" label="NO">NO</el-radio>
                     <el-button @click="field.default_value = ''">None Selected</el-button>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
            <el-col :span="12">
          <field-filled-by :field="field" />
        </el-col>
 </el-row>
          <el-row :gutter="30">
        
        <el-col :span="12">
          <div class="mt-2 field-required">
            <el-row :gutter="10">
              <el-col :span="12">
                <is-field-required :field="field" class="field-required"/>
              </el-col>
              <el-col :span="10">
       
                <div class="icon-dropdown-selection">
            <el-button type="text" @click="iconPickerdialogVisible = true">
              <div class="d-flex align-center menu-icon">
                <span>
                  <icons :iconName="templateIconPath"></icons>
                </span>
                <i class="el-icon-circle-plus"></i>
              </div>
            </el-button>
          </div>
              </el-col>    
            </el-row>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <dialog-component
      :title="'Select An Icon'"
      :visible="iconPickerdialogVisible"
      :containerWidth="getIsMobile ? '100%' : '77%'"
      @before-close="closeSelectIcon"
      :isShowFooter="false"
      :selectedIcon="field.icon_name"
    >
      <div class="icons-component">
        <div class="iconslistScrollable">
          <icons-list @icon-data="getIconPath"></icons-list>
        </div>
      </div>
    </dialog-component>
  </div>
</template>

<script>
// import TitleAndDescription from "./TitleAndDescription";
// import FieldFilledBy from "./FieldFilledBy";

export default {
  name: "templates-formComponents-YesOrNo",
  props: ["field"],
  components: {
     "TitleAndDescription":()=>import("./TitleAndDescription.vue"),
     "IsFieldRequired":()=>import("./IsFieldRequired"),
     "FieldFilledBy":()=>import("./FieldFilledBy.vue") 
     },
  data() {
    return {
      validations: [],
      iconPickerdialogVisible: false,
    };
  },
  methods:{
    closeSelectIcon() {
      this.iconPickerdialogVisible = false;
    },
    getIconPath(icon) {
      this.templateIconPath = icon;
      this.$set(this.field, 'icon_name', icon);
      this.iconPickerdialogVisible = false;
    },
  }
};
</script>

<style lang="scss">
</style>
